import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  MainBlock,
  ContentsBlock,
  ContentsTitle,
} from './styles/ActionLogTitleStyles';

const ActionLogTitle = () => (
  <MainBlock id="ActionLogTitle">
    <ContentsBlock>
      <ContentsTitle>
        <FormattedMessage id="actionLog.title" />
      </ContentsTitle>
    </ContentsBlock>
  </MainBlock>
);

export default ActionLogTitle;
